import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Services";
import getToken from "app/api/getToken";
import { IService } from "app/api/types";

export const ADD_SERVICE_REQUEST = "ADD_SERVICE_REQUEST";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAIL = "ADD_SERVICE_FAIL";

export const addService = (data: IService) => (dispatch: any): any => {
  dispatch({ type: ADD_SERVICE_REQUEST });

  const token = getToken();

  return api
    .addService(token, data)
    .then((response: AxiosResponse) => {
      const service: IService = get(response, "data", {});
      dispatch({ type: ADD_SERVICE_SUCCESS, payload: service });

      return service;
    })
    .catch(err => {
      dispatch({
        type: ADD_SERVICE_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
